<template>
  <div class="w-full overflow-y-auto [&:not(:first-child)]:mt-6 [&:not(:last-child)]:mb-6">
    <table class="w-full">
      <slot />
    </table>
  </div>
</template>
